module.exports = __webpack_public_path__ + "static/media/Neutralizante.35a0520d.jpeg";